import { wait, waitForElement } from "@testing-library/react";
import AppState from "./AppState";


class SpeecHelper {

    openflDivRef = null

    /* list of ids that has to be loaded in canvas */
    currentIds = []
    
    /* Loaded characters in their canvas */
    characters = []

    /* Current canvas speaker */
    currentCanvasSpeaker = null

    isDialoguePlaying = false
    isSkipping = false

    textCb = null

    isInit = false

    constructor() {
        //  = window.document.querySelector("#openfl-dials")
    }

    createDialDiv(container) {
      return new Promise( (resolve, reject) => {

        this.openflDivRef = document.createElement("div");
        this.openflDivRef.id = "openfl-dials";

        container.appendChild(this.openflDivRef)

        setTimeout(() => {
          window.lime.embed("speechlib", "openfl-dials", 0, 0, { parameters: {} })
          resolve()
        }, 100)

        // wait(() => { 

        // }, 100)
        
      })
    }

    // setDialDiv(div) {
      // console.log(div)

      // window.lime.embed("speechlib", "openfl-test", 0, 0, { parameters: {} })
      // this.openflDivRef = window.document.querySelector("#openfl-test")

      // window.SpeechAPI.setLogLevel(6)
      // window.SpeechAPI.enableBackToNeutral(true, 0.5)
    // }


    loadSpeechCharacter(charFilePath, chars) {
      return new Promise( (resolve, reject) => {
        window.SpeechAPI.initCharacters(charFilePath, () => {
          try {
            window.SpeechAPI.loadCharacterIds(chars)
          }
          catch(err) {
            console.error("Error while loading characters for SpeechLib :")
            console.error(err)
          }

          resolve()
        })
      })
    }

    unloadCharacters(chars) {
        // cleaning canvas character
        this.currentIds.filter(id => chars.indexOf(id) != -1)
        this.characters.filter(char => chars.indexOf(char.charId) != -1)

        // cleaning characters in speechApi
        window.SpeechAPI.deleteCharacters(chars)
    }

    prepareSpeechScene(speechLevelPath, firstChar) {
        return new Promise( (resolve, reject) => {
            window.SpeechAPI.prepareSpeechLevel(speechLevelPath, firstChar, () => {
                this.openflDivRef.classList.add("visible")

                resolve()
            })
        })
    }
    
    // Create the list of ids used to create the canvas needed to draw the characters
    prepareCanvasCharacters(chars) {
        return new Promise( (resolve, reject) => {
            this.currentIds = chars
  
            let pingInt = setInterval(() => {
              var check = true;
  
              if(this.characters.length > 0) {
                this.currentIds.forEach(id => {
                  if(this.characters.map(char => char.charId).indexOf(id) === -1) {
                    check = false
                  }
                });
              }
              else check = false
  
              if(check) {
                clearInterval(pingInt)
                resolve()
              }
            }, 100)
          })
    }

    // Add a character to its canvas
    initCharacterFromCanvas(id, canvas) {
        this.characters.push(window.SpeechAPI.createCanvasCharacter(id, canvas.id))
        
        if(this.textCb) this.characters[this.characters.length - 1].setTextCallback(this.textCb)

        return this.characters[this.characters.length - 1]
    }

    closeSpeechScene() {
        return new Promise( (resolve, reject) => {
            window.SpeechAPI.closeCurrentScene(() => {
            
                this.openflDivRef.classList.remove("visible")

                resolve()
            })
        })
    }
    
    cleanCanvasCharacters() {
        this.currentIds = []
        this.character = []
    }

    loadAudios(audios) {
        window.SpeechAPI.streamAudios(audios)
    }

    unloadAudios(audios) {
        window.SpeechAPI.deleteAudios(audios)
    }

    playDialogue(dial, cb) {
      if(!dial) {
        return
      }
      if(this.isDialoguePlaying) {
          this.handleSkip()
      }
      
      this.currentCanvasSpeaker = this.getCanvasCharacter(dial.character)
      /* if the canvas chracter doesn't exist it means that it's a speech level dial */
      
      if(this.currentCanvasSpeaker != null) this.currentCanvasSpeaker.playContent(dial.text, dial.textTimings, dial.attitudeTimings, dial.audio, () => this.handleDialEnded(cb))             
      else {
        window.SpeechAPI.showContent(dial.character, dial.text, dial.textTimings, dial.attitudeTimings, dial.audio, dial.vue, () => { this.handleDialEnded(cb) })
      }
      
      if(this.textCb) this.textCb(dial.text)
      
      this.isDialoguePlaying = true
    }

    setTextCallback(textCb) {
        this.textCb = textCb

        console.log(this.textCb)

        window.SpeechAPI.setTextCallback(this.textCb)

        this.characters.forEach(char => char.setTextCallback(this.textCb))
    }

    handleDialEnded(cb) {
        this.currentCanvasSpeaker = null
        this.isDialoguePlaying = false

        if(this.isSkipping) {
          this.isSkipping = false
          return
        }
        if(cb) cb()
    }

    handleSkip() {
        if(this.isDialoguePlaying == false) return

        this.isSkipping = true;

        if(this.currentCanvasSpeaker) this.currentCanvasSpeaker.skipSegment()
        else window.SpeechAPI.skipSegment()
    }

    handlePause() {
      if(this.currentCanvasSpeaker) this.currentCanvasSpeaker.pause()
      else window.SpeechAPI.pause()
    }

    handleResume() {
      if(this.currentCanvasSpeaker) this.currentCanvasSpeaker.resume()
      else window.SpeechAPI.resume()
    }

    getCanvasCharacter(id) {
        return this.characters.find(char => char.charId === id)
    }
}
export default new SpeecHelper()